exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "duk {\n  display: block;\n  margin-bottom: 30px;\n}", ""]);

// exports
